import React from 'react';

import { first, last } from 'lodash';
import type { CellProps, Column } from 'react-table';
import type { Alert } from '@bringg/types';

import { EXCEPTIONS_COLUMN_IDS, TRANSLATION_DOMAINS } from '../../../consts';
import { Translate } from '../../../translation';
import type { Exception } from '../../../types/common.consts';

export interface ExceptionCellProps<V = any> extends CellProps<Exception, V> {}
export interface AlertCellProps<V = any> extends CellProps<Alert, V> {}
export interface CommonCellProps<V = any> extends CellProps<Pick<Exception, 'team_id' | 'id' | 'owner_id'>, V> {}

export interface StrictId {
	id: string;
}
export type ColumnWithStrictId<T extends Record<string, unknown>> = Column<T> & StrictId;

export function getActiveWayPoint({ active_way_point_id, way_points }: Exception) {
	return active_way_point_id && way_points?.length ? way_points.find(({ id }) => id === active_way_point_id) : null;
}

export function getFirstStopWayPoint({ way_points }: Exception) {
	return Array.isArray(way_points) ? first(way_points) : null;
}

export function getLastStopWayPoint({ way_points }: Exception) {
	return Array.isArray(way_points) ? last(way_points) : null;
}

export function nullableObjectField<T>(o: T, k: keyof T): string {
	return o && o[k] ? String(o[k]) : '-';
}

export const filterOutIds = new Set([EXCEPTIONS_COLUMN_IDS.SELECTION_COLUMN, EXCEPTIONS_COLUMN_IDS.ACTIONS]);

export function columnMapper<T extends Record<string, unknown>>(col: Column<T>): ColumnWithStrictId<T> {
	const translateKey = `${TRANSLATION_DOMAINS.EXCEPTIONS_LIST}.${col.translateKey}`;

	return Object.assign<Record<string, unknown>, Column<T>, Partial<ColumnWithStrictId<T>> & StrictId>({}, col, {
		translateKey,
		Header: col.Header || <Translate text={translateKey} />,
		// react-table ColumnInstance id field infer logic duplicate
		// we need id on Column as part of the HiddenColumns state management
		id: col.id || (typeof col.accessor === 'string' ? String(col.accessor) : undefined)
	});
}

export const ALWAYS_ACTIVE_FIRST_COLUMNS = [EXCEPTIONS_COLUMN_IDS.ALERT_TYPE, EXCEPTIONS_COLUMN_IDS.ALERT_TIME];
